/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import axios from 'axios';

export const state = {
  config: {},
  configLoaded: false,
  configLoading: false,
};

export const actions = {
  async fetchConfiguration({ commit, state }) {
    if (!state.configLoaded && !state.configLoading) {
      commit('SET_LOADING', true);
      await axios.get('/config.json')
        .then((response) => {
          commit('SET_CONFIGURATION', response.data);
          commit('SET_LOADING', false);
          commit('SET_LOADED');
        });
    }
  },
};

export const mutations = {
  SET_CONFIGURATION(state, config) {
    state.config = config;
  },
  SET_LOADING(state, loading) {
    state.configLoading = loading;
  },
  SET_LOADED(state) {
    state.configLoaded = true;
  },
};
